/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccountGroupUpdateRequest
 */
export interface AccountGroupUpdateRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof AccountGroupUpdateRequest
     */
    name?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AccountGroupUpdateRequest
     */
    lc?: Array<string>;
}

/**
 * Check if a given object implements the AccountGroupUpdateRequest interface.
 */
export function instanceOfAccountGroupUpdateRequest(value: object): value is AccountGroupUpdateRequest {
    return true;
}

export function AccountGroupUpdateRequestFromJSON(json: any): AccountGroupUpdateRequest {
    return AccountGroupUpdateRequestFromJSONTyped(json, false);
}

export function AccountGroupUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountGroupUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'lc': json['lc'] == null ? undefined : json['lc'],
    };
}

export function AccountGroupUpdateRequestToJSON(json: any): AccountGroupUpdateRequest {
    return AccountGroupUpdateRequestToJSONTyped(json, false);
}

export function AccountGroupUpdateRequestToJSONTyped(value?: AccountGroupUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'lc': value['lc'],
    };
}

